export const isHubspotAndroid = window.navigator.userAgent.indexOf('HubSpotAndroid') > -1;
export const isHubSpotNativeApp = window.navigator.userAgent.indexOf('HubSpotiOS') > -1 || isHubspotAndroid;
export const getPlatform = () => {
  if (isHubspotAndroid) {
    return 'android-webview';
  }
  if (isHubSpotNativeApp) {
    return 'ios-webview';
  }
  return undefined;
};